import type { PostBlock } from '@news-cms/shared';

function escapeHtml(s: string): string {
  return s
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

/**
 * Convert stored PostBlock[] into HTML for the editor's initial content.
 * Handles two block shapes:
 *  - `html`: TipTap's own output stored verbatim → return data.html
 *  - `paragraph`: legacy F.1 textarea blocks → wrap each line in <p>
 */
export function htmlFromBlocks(blocks: PostBlock[] | null | undefined): string {
  if (!blocks || blocks.length === 0) return '';
  return blocks
    .map((block) => {
      if (block.type === 'html') {
        const html = block.data?.['html'];
        return typeof html === 'string' ? html : '';
      }
      if (block.type === 'paragraph') {
        const text = block.data?.['text'];
        if (typeof text !== 'string' || text.length === 0) return '';
        return text
          .split('\n')
          .filter((l) => l.length > 0)
          .map((l) => `<p>${escapeHtml(l)}</p>`)
          .join('');
      }
      return '';
    })
    .filter(Boolean)
    .join('');
}
